module.exports = __webpack_public_path__ + "static/media/190611_ChevalierCuivre-02.828ed9cd.png";